import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=7220e3a0&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220e3a0",
  null
  
)

export default component.exports